import React from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText, Divider } from '@mui/material';

const HowTo = () => {
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom>
        使い方
      </Typography>

      {/* 手順説明 */}
      <Typography variant="h6" gutterBottom>
        🌟 基本的な使い方
      </Typography>
      <List>
        <ListItem>
          <ListItemText
            primary="① 画像をドラッグ&ドロップ"
            secondary="リサイズしたい画像ファイルをアプリの指定エリアにドラッグ&ドロップします。"
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="② 解像度を指定"
            secondary="任意の解像度（例：1024×1024）を入力し、「リサイズ」ボタンをクリックします。"
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="③ ダウンロードして完了"
            secondary="処理が完了したら、リサイズされた画像をダウンロードできます。"
          />
        </ListItem>
      </List>

      <Divider sx={{ my: 4 }} />

      {/* 対応形式と制限 */}
      <Typography variant="h6" gutterBottom>
        ✅ 対応形式と制限事項
      </Typography>
      <Typography paragraph>
        本アプリでは以下の画像形式に対応しています：
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="対応形式：" secondary="JPEG / PNG / WEBP" />
        </ListItem>
        <ListItem>
          <ListItemText primary="最大ファイルサイズ：" secondary="10MBまで" />
        </ListItem>
        <ListItem>
          <ListItemText primary="最大解像度：" secondary="4096×4096ピクセルまで" />
        </ListItem>
      </List>

      <Divider sx={{ my: 4 }} />

      {/* 注意事項 */}
      <Typography variant="h6" gutterBottom>
        ⚠️ 注意事項
      </Typography>
      <Typography paragraph>
        - 高解像度の画像をリサイズする際は処理に時間がかかる場合があります。
        - 大量の画像を一度に処理すると、アプリの応答が遅くなる可能性があります。
        - 著作権のある画像を無断で使用・加工することは禁止されています。
      </Typography>

      <Divider sx={{ my: 4 }} />

      {/* FAQ */}
      <Typography variant="h6" gutterBottom>
        💡 よくある質問（FAQ）
      </Typography>
      <List>
        <ListItem>
          <ListItemText
            primary="Q: 複数画像を一度にリサイズできますか？"
            secondary="現在は1枚ずつのリサイズのみ対応しています。"
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Q: 解像度をカスタム指定できますか？"
            secondary="はい。任意の幅と高さを指定できます。"
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Q: 処理速度が遅い場合はどうすれば良いですか？"
            secondary="ファイルサイズを小さくするか、解像度を下げることで高速化できます。"
          />
        </ListItem>
      </List>

      <Divider sx={{ my: 4 }} />

      {/* 広告エリア */}
      <Box sx={{ my: 5, textAlign: 'center', p: 2, bgcolor: '#f0f0f0', borderRadius: 2 }}>
        <Typography variant="body2" color="textSecondary">
          広告エリア（AdSenseコードを配置）
        </Typography>
      </Box>
    </Container>
  );
};

export default HowTo;
